import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Icon } from 'src/components/icons';
import { Picture } from 'src/components/picture';
import { breakpointTablet } from 'src/styles/breakpoints';
import { colorSecondary200, colorSecondary700, colorSecondary900 } from 'src/styles/colors';
import { changeIconFillColor, changeIconStrokeColor, focus } from 'src/styles/mixins';
import { spacing0, spacing1, spacing2, spacing3, spacing5 } from 'src/styles/spacing';

export const StyledProductContainer = styled.div`
  display: flex;
  padding: ${spacing3} 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${colorSecondary200};
  }

  &:first-child {
    padding-top: 0;
  }

  @media (min-width: ${breakpointTablet}) {
    padding: ${spacing5} 0;

    &:first-child {
      padding-top: ${spacing2};
    }
  }
`;

export const StyledProductInformation = styled.div`
  flex: 1;
`;

export const StyledContainer = styled.div`
  display: flex;
  padding-left: ${spacing1};
  margin-left: auto;
`;

export const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing1};
`;

export const StyledImage = styled(Picture)`
  display: none;

  @media (min-width: ${breakpointTablet}) {
    max-height: 46px;
    margin-top: ${spacing2};
    margin-right: ${spacing2};
    display: block;
  }
`;

export const StyledQuantityRow = styled.div`
  padding-top: ${spacing0};
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  @media (min-width: ${breakpointTablet}) {
    padding-top: ${spacing1};
  }
`;

export const StyledQuantityText = styled(Typography)`
  padding-right: ${spacing0};
`;

export const StyledCommonButton = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0;
`;

export const StyledDeleteButton = styled(StyledCommonButton)`
  &:hover {
    cursor: pointer;
    ${changeIconStrokeColor(colorSecondary700)};
  }

  ${focus};
`;

export const StyledEditIcon = styled(Icon)`
  padding-right: ${spacing0};
`;

export const StyledEditButton = styled(StyledCommonButton)`
  margin-left: ${spacing1};
  display: flex;

  &:hover {
    cursor: pointer;

    ${StyledEditIcon} {
      ${changeIconFillColor(colorSecondary700)}
    }

    & p {
      color: ${colorSecondary700};
    }
  }

  ${focus};
`;

export const StyledSetupPrice = styled(Typography)`
  color: ${colorSecondary700};

  &:not(:first-child) {
    padding-left: ${spacing1};
  }

  @media (min-width: ${breakpointTablet}) {
    color: ${colorSecondary900};
  }
`;
